export function remainingCredit(customer) {
  return Math.max(0, (customer?.creditLimit ?? 0) - (customer?.exposure ?? 0));
}

// Hvem som betaler et fakturaoppdrag. Org foretrekkes når den er godkjent og brukeren er medlem;
// ellers personlig godkjenning. payerType følger firestore.rules ('org' krever org_<orgId>, null krever user_<uid>).
export function resolveInvoicePayer({ userDoc, personal, org }) {
  if (userDoc?.orgId && org?.approved === true) return { payerType: 'org', customer: org };
  if (personal?.approved === true) return { payerType: null, customer: personal };
  return null;
}
